// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2o-6-","list":"BalanceDue_list__zrRUW","listRow":"BalanceDue_listRow__2bvGF","total":"BalanceDue_total__1l23d"};